import { HttpClient } from '@angular/common/http';
import { Component, effect, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { GeneralService } from 'src/app/services/general.service';
import { StateService } from 'src/app/services/state.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-incorp-progress',
  templateUrl: './incorp-progress.page.html',
  styleUrls: ['./incorp-progress.page.scss'],
})
export class IncorpProgressPage {

  constructor(
    private nav: NavController,
    private dataService: DataService,
    private http: HttpClient,
    private generalService: GeneralService,
    private stateService: StateService,
    protected modalCtrl: ModalController
  ) {

    effect(() => {
      this.currentCompany = this.stateService.companyDetails

      // if (this.currentCompany['companyID'] == null || this.currentCompany['companyID'] == '') {
      //   this.generalService.showMessage('Warning!', "You haven't completed your application!", 'warning')
      //   this.nav.navigateForward('tabs/tab4')
      //   return
      // }

      if (Object.values(this.currentCompany).length > 0 && this.currentCompany['companyID'] && !this.hasProgressBarAppointCompanySecretaryRun) {

        this.showNoCompany = false

        // Appoint Company Secretary Status
        this.http.post(baseUrl + '/progressBarAppointCompanySecretary', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarAppointCompanySecretaryData = result;

          if (this.progressBarAppointCompanySecretaryData.length == 0) {
            this.picAppointCompanySecretaryStatus = "N";

          } else {
            this.picAppointCompanySecretaryStatus = "Y";
            this.completedTasks++;
            //console.log('Completed tasks:', this.completedTasks);

          }

          this.hasProgressBarAppointCompanySecretaryRun = true;

        });

        // Open Bank Account Status
        this.http.post(baseUrl + '/progressBarOpenBankAccount', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarOpenBankAccountData = result;

          if (this.progressBarOpenBankAccountData.length == 0) {
            this.picOpenBankAccountStatus = "N";
          } else {
            this.picOpenBankAccountStatus = "Y";
            this.completedTasks++;
            // console.log('Completed tasks:', this.completedTasks);
          }

        });

        // Apply Business License Status
        this.http.post(baseUrl + '/progressBarApplyBusinessLicense', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarApplyBusinessLicenseData = result;

          if (this.progressBarApplyBusinessLicenseData.length == 0) {
            this.picApplyBusinessLicenseStatus = "N";
          } else {
            this.picApplyBusinessLicenseStatus = "Y";
            this.completedTasks++;
            // console.log('Completed tasks:', this.completedTasks);
          }

        });

        // Fix Financial Year End Status
        this.http.post(baseUrl + '/progressBarFixFinancialYearEnd', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarFixFinancialYearEndData = result;

          if (this.progressBarFixFinancialYearEndData.length == 0) {
            this.picFixFinancialYearEndedStatus = "N";
          } else {
            this.picFixFinancialYearEndedStatus = "Y";
            this.completedTasks++;
            // console.log('Completed tasks:', this.completedTasks);
          }

        });

        // Appoint Auditor Status
        this.http.post(baseUrl + '/progressBarAppointAuditor', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarAppointAuditorData = result;

          if (this.progressBarAppointAuditorData.length == 0) {
            this.picAppointAuditorStatus = "N";
          } else {
            this.picAppointAuditorStatus = "Y";
            this.completedTasks++;
            //  console.log('Completed tasks:', this.completedTasks);
          }

        });

        // Appoint Tax Agent Status
        this.http.post(baseUrl + '/progressBarAppointTaxAgent', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarAppointTaxAgentData = result;

          if (this.progressBarAppointTaxAgentData.length == 0) {
            this.picAppointTaxAgentStatus = "N";
          } else {
            this.picAppointTaxAgentStatus = "Y";
            this.completedTasks++;
            //  console.log('Completed tasks:', this.completedTasks);
          }

        });

        // Payroll Status
        this.http.post(baseUrl + '/progressBarPayroll', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarPayrollData = result;

          if (this.progressBarPayrollData.length == 0) {
            this.picPayrollStatus = "N";
          } else {
            this.picPayrollStatus = "Y";
            this.completedTasks++;
            // console.log('Completed tasks:', this.completedTasks);
          }

        });


        // Annual Return Status

        this.http.post(baseUrl + '/progressBarAnnualReturn', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarAnnualReturnData = result;
          console.log(this.progressBarAnnualReturnData)
          console.log('Annual Return')

          if (this.progressBarAnnualReturnData.length != 0) {

            for (let i = 0; i < this.progressBarAnnualReturnData.length; i++) {
              if (this.currentYear == this.extractYear(this.progressBarAnnualReturnData[i].TITLE) && this.progressBarAnnualReturnData[i].STAGE_ID !== "C29:WON") {
                this.acAnnualReturnYear.push(this.extractYear(this.progressBarAnnualReturnData[i].TITLE) + this.extractPrefix(this.progressBarAnnualReturnData[i].STAGE_ID));
                this.deadlineAR = this.progressBarAnnualReturnData[i].UF_CRM_1658920721669;
              }
              if (this.currentYear1 == this.extractYear(this.progressBarAnnualReturnData[i].TITLE) && this.progressBarAnnualReturnData[i].STAGE_ID !== "C29:WON") {
                this.acAnnualReturnYear1.push(this.extractYear(this.progressBarAnnualReturnData[i].TITLE) + this.extractPrefix(this.progressBarAnnualReturnData[i].STAGE_ID));
                this.deadlineAR = this.progressBarAnnualReturnData[i].UF_CRM_1658920721669;
              }
              if (this.currentYear2 == this.extractYear(this.progressBarAnnualReturnData[i].TITLE) && this.progressBarAnnualReturnData[i].STAGE_ID !== "C29:WON") {
                this.acAnnualReturnYear2.push(this.extractYear(this.progressBarAnnualReturnData[i].TITLE) + this.extractPrefix(this.progressBarAnnualReturnData[i].STAGE_ID));
                this.deadlineAR = this.progressBarAnnualReturnData[i].UF_CRM_1658920721669;
              }

            }

          } else {
            this.acAnnualReturnStatus = "N";
          }

          this.acAnnualReturnYear = [...new Set(this.acAnnualReturnYear.sort((a, b) => b - a))];
          this.acAnnualReturnYear1 = [...new Set(this.acAnnualReturnYear1.sort((a, b) => b - a))];
          this.acAnnualReturnYear2 = [...new Set(this.acAnnualReturnYear2.sort((a, b) => b - a))];

        });

        // Audited Financial Report Compliation Report Status
        this.http.post(baseUrl + '/progressBarAuditedFinancialReportCompliationReport', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarAuditedFinancialReportCompliationReportData = result;

          if (this.progressBarAuditedFinancialReportCompliationReportData.length != 0) {

            for (let i = 0; i < this.progressBarAuditedFinancialReportCompliationReportData.length; i++) {

              if (this.currentYear == this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) && this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID !== "C31:WON") {
                this.acAnnualReturnYear.push(this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) + this.extractPrefix(this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID));
                this.deadlineAFS = this.progressBarAuditedFinancialReportCompliationReportData[i].UF_CRM_1643166543704;
              }
              if (this.currentYear1 == this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) && this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID !== "C31:WON") {
                this.acAnnualReturnYear1.push(this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) + this.extractPrefix(this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID));
                this.deadlineAFS = this.progressBarAuditedFinancialReportCompliationReportData[i].UF_CRM_1643166543704;
              }
              if (this.currentYear2 == this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) && this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID !== "C31:WON") {
                this.acAnnualReturnYear2.push(this.extractYear(this.progressBarAuditedFinancialReportCompliationReportData[i].TITLE) + this.extractPrefix(this.progressBarAuditedFinancialReportCompliationReportData[i].STAGE_ID));
                this.deadlineAFS = this.progressBarAuditedFinancialReportCompliationReportData[i].UF_CRM_1643166543704;
              }
            }
            // console.log(this.acAnnualReturnYear1)
          } else {
            this.acAuditedFinancialReportCompliationReportStatus = "N";
          }

          this.acAnnualReturnYear = [...new Set(this.acAnnualReturnYear.sort((a, b) => b - a))];
          this.acAnnualReturnYear1 = [...new Set(this.acAnnualReturnYear1.sort((a, b) => b - a))];
          this.acAnnualReturnYear2 = [...new Set(this.acAnnualReturnYear2.sort((a, b) => b - a))];

        });

        // Employer Form Filling Status
        this.http.post(baseUrl + '/progressBarEmployerFormFilling', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarEmployerFormFillingData = result;

          if (this.progressBarEmployerFormFillingData.length != 0) {

            for (let i = 0; i < this.progressBarEmployerFormFillingData.length; i++) {

              if (this.currentYear == this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) && this.progressBarEmployerFormFillingData[i].STAGE_ID !== "C95:WON") {
                this.acAnnualReturnYear.push(this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) + this.extractPrefix(this.progressBarEmployerFormFillingData[i].STAGE_ID));
                this.deadlineE = this.progressBarEmployerFormFillingData[i].UF_CRM_1617760394;
              }
              if (this.currentYear1 == this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) && this.progressBarEmployerFormFillingData[i].STAGE_ID !== "C95:WON") {
                this.acAnnualReturnYear1.push(this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) + this.extractPrefix(this.progressBarEmployerFormFillingData[i].STAGE_ID));
                this.deadlineE = this.progressBarEmployerFormFillingData[i].UF_CRM_1617760394;
              }
              if (this.currentYear2 == this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) && this.progressBarEmployerFormFillingData[i].STAGE_ID !== "C95:WON") {
                this.acAnnualReturnYear2.push(this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) + this.extractPrefix(this.progressBarEmployerFormFillingData[i].STAGE_ID));
                this.deadlineE = this.progressBarEmployerFormFillingData[i].UF_CRM_1617760394;
              }

            }

          } else if (this.progressBarEmployerFormFillingData.length != 0) {

            for (let i = 0; i < this.progressBarEmployerFormFillingData.length; i++) {
              if (this.currentYear1 == this.extractYear(this.progressBarEmployerFormFillingData[i].TITLE) && this.progressBarEmployerFormFillingData[i].STAGE_ID == "C95:WON") {
                // console.log(this.progressBarEmployerFormFillingData)
                this.acFormESubmissionStatus = "Y";
              }
            }
          }
          else {
            this.acFormESubmissionStatus = "N";
          }

          this.acAnnualReturnYear = [...new Set(this.acAnnualReturnYear.sort((a, b) => b - a))];
          this.acAnnualReturnYear1 = [...new Set(this.acAnnualReturnYear1.sort((a, b) => b - a))];
          this.acAnnualReturnYear2 = [...new Set(this.acAnnualReturnYear2.sort((a, b) => b - a))];

        });

        // Corporate Tax Filling Status
        this.http.post(baseUrl + '/progressBarCorporateTaxFilling', { companyId: this.currentCompany['companyID'] }).subscribe((result) => {
          this.progressBarCorporateTaxFillingData = result;

          if (this.progressBarCorporateTaxFillingData.length != 0) {

            for (let i = 0; i < this.progressBarCorporateTaxFillingData.length; i++) {

              if (this.currentYear == this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) && this.progressBarCorporateTaxFillingData[i].STAGE_ID !== "C87:WON") {
                this.acAnnualReturnYear.push(this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) + this.extractPrefix(this.progressBarCorporateTaxFillingData[i].STAGE_ID));
                this.deadlineC = this.progressBarCorporateTaxFillingData[i].UF_CRM_1614848700569;
              }
              if (this.currentYear1 == this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) && this.progressBarCorporateTaxFillingData[i].STAGE_ID !== "C87:WON") {
                this.acAnnualReturnYear1.push(this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) + this.extractPrefix(this.progressBarCorporateTaxFillingData[i].STAGE_ID));
                this.deadlineC = this.progressBarCorporateTaxFillingData[i].UF_CRM_1614848700569;
              }
              if (this.currentYear2 == this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) && this.progressBarCorporateTaxFillingData[i].STAGE_ID !== "C87:WON") {
                this.acAnnualReturnYear2.push(this.extractYear(this.progressBarCorporateTaxFillingData[i].TITLE) + this.extractPrefix(this.progressBarCorporateTaxFillingData[i].STAGE_ID));
                this.deadlineC = this.progressBarCorporateTaxFillingData[i].UF_CRM_1614848700569;
              }

            }

          } else {
            this.acFormCFillingStatus = "N";
          }

          this.acAnnualReturnYear = [...new Set(this.acAnnualReturnYear.sort((a, b) => b - a))];
          this.acAnnualReturnYear1 = [...new Set(this.acAnnualReturnYear1.sort((a, b) => b - a))];
          this.acAnnualReturnYear2 = [...new Set(this.acAnnualReturnYear2.sort((a, b) => b - a))];

        });

      } else {
        this.showNoCompany = true
      }
    })
  }


  Open = 'Open';

  showNoCompany = true

  currentCompany = {};
  usersubscribe;
  progressBar;
  taskId;
  currentCompanyName;
  completedTasks: number = 0;
  totalTasks: number = 8;
  picID;
  acID;
  progressBarData;//no need
  hasProgressBarAppointCompanySecretaryRun: boolean = false;
  progressBarAppointCompanySecretaryData;
  progressBarOpenBankAccountData;
  progressBarApplyBusinessLicenseData;
  progressBarFixFinancialYearEndData;
  progressBarAppointAuditorData;
  progressBarAppointTaxAgentData;
  progressBarPayrollData;
  progressBarAnnualReturnData;
  progressBarAuditedFinancialReportCompliationReportData;
  progressBarEmployerFormFillingData;
  progressBarCorporateTaxFillingData;

  picAppointCompanySecretaryStatus;
  picOpenBankAccountStatus;
  picApplyBusinessLicenseStatus;
  picFixFinancialYearEndedStatus;
  picAppointAuditorStatus;
  picAppointTaxAgentStatus;
  picPayrollStatus;
  acAnnualReturnStatus;
  acAuditedFinancialReportCompliationReportStatus;
  acFormESubmissionStatus;
  acFormCFillingStatus;

  acAnnualReturnYear = [];
  acAnnualReturnYear1 = [];
  acAnnualReturnYear2 = [];
  acAnnualReturnYearShow = [];
  acAnnualReturnYearShowNYear = [];
  acAuditedFinancialReportCompliationReportYear = [];
  acAuditedFinancialReportCompliationReportYearShow = [];
  acAuditedFinancialReportCompliationReportYearShowNYear = [];
  acFormESubmissionYear = [];
  acFormESubmissionYearShow = [];
  acFormESubmissionYearShowNYear = [];
  acFormCFillingYear = [];
  acFormCFillingYearShow = [];
  acFormCFillingYearShowNYear = [];

  // <----- FusionETA - Alvin (29 November 2023) - deadline(annualcompliance) - Start ---->
  deadlineAR;
  deadlineAFS;
  deadlineE;
  deadlineC;
  // <----- FusionETA - Alvin (29 November 2023) - deadline(annualcompliance) - End ---->

  currentYear: number = (new Date().getFullYear()) + 1;
  currentYear1 = this.currentYear - 1;
  currentYear2 = this.currentYear - 2;



  ngOnInit() {
    this.completedTasks = 0;
    this.totalTasks = 8;


  }

  // <----- FusionETA - Alvin (17 January 2024) - Lock View - start ------------>
  ionViewDidEnter() {
    // if (this.currentCompany['companyID'] == null || this.currentCompany['companyID'] == '') {
    //   this.generalService.showMessage('Warning!', "You haven't completed your application!", 'warning')
    //   this.nav.navigateForward('tabs/tab4')
    //   return
    // }
  }
  // <----- FusionETA - Alvin (17 January 2024) - Lock View - End ------------>

  /** calculate progress
      calculateProgress(): number {
        if (this.totalTasks === 0) {
          console.log('completedTasks:', this.completedTasks);
    console.log('totalTasks:', this.totalTasks);
          return 0; // To avoid division by zero
        }
      
        const progress = (this.completedTasks / this.totalTasks) * 8;
      
        console.log('progress:', progress);
        // Ensure the progress is between 0 and 8
        return Math.min(Math.max(progress, 0), 8);
        
      }*/

  banklink() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/open-bank')
  }

  fixfy() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/change-financial-year')
  }

  appointauditor() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/change-auditor')
  }

  appointtaxagent() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/appoint-tax-agent')
  }

  payroll() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/others')
  }

  businesslicenselink() {
    this.modalCtrl.dismiss()
    this.nav.navigateForward('resolutions/others')
  }

  extractYear(inputString) {
    const lastFiveCharacters = inputString.slice(-5); // Get the last five characters
    const extractedYear = lastFiveCharacters.replace(/\D/g, ''); // Remove the trailing ']' character
    return extractedYear;
  }

  extractPrefix(inputString) {
    return inputString.slice(0, 3); // Get the first three characters
  }
}

